var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTerms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.878 2H7.628C6.112 2 4.885 3.269 4.885 4.834v13.06h9.876v2.068c0 1.016.797 1.84 1.78 1.84h.224v.034a2.239 2.239 0 0 0 1.35-2.073V3.833c0-.721.293-1.372.762-1.833Zm-3.795 20a2.56 2.56 0 0 1-.994-2.038V18.59H2v.576C2 20.731 3.227 22 4.742 22h10.34Zm5.381-19.848c-.853.053-1.53.785-1.53 1.681V5.26H22V3.84c0-.9-.68-1.635-1.536-1.688ZM7 6c0-.276.283-.5.632-.5h7.736c.35 0 .632.224.632.5s-.283.5-.632.5H7.632C7.282 6.5 7 6.276 7 6Zm0 3c0-.276.283-.5.632-.5h2.236c.35 0 .632.224.632.5s-.283.5-.632.5H7.632C7.282 9.5 7 9.276 7 9Zm.632 2.5c-.35 0-.632.224-.632.5s.283.5.632.5h7.736c.35 0 .632-.224.632-.5s-.283-.5-.632-.5H7.632ZM7 15c0-.276.283-.5.632-.5h4.736c.35 0 .632.224.632.5s-.283.5-.632.5H7.632c-.35 0-.632-.224-.632-.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerms);
export default __webpack_public_path__ + "static/media/terms.7856d6117af91c0b1d22c2175ae9866b.svg";
export { ForwardRef as ReactComponent };